import Icon from '../components/Icon.vue'

Icon.register({
  backward: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M11.5 280.6c-15.3-12.8-15.3-36.4 0-49.2l192-160c20.6-17.2 52.5-2.8 52.5 24.6v320c0 27.4-31.9 41.8-52.5 24.6zM267.5 280.6c-15.3-12.8-15.3-36.4 0-49.2l192-160c20.6-17.2 52.5-2.8 52.5 24.6v320c0 27.4-31.9 41.8-52.5 24.6z'
      }
    ]
  }
})
